/**
 * Canonicalise a typed hex colour to `#RRGGBB`, or null when it is not one.
 *
 * Mirrors the ACCEPTED FORMS of the server's `hexToRgb`
 * (packages/server/src/services/contrastAnalysis.ts:8-19): 3- or 6-digit, with
 * or without the leading hash, surrounding whitespace tolerated. Used for the
 * swatch, the dirty check and the preview query only; whether a colour is
 * READABLE stays the server's verdict (services/brandingContrast.ts), which
 * BrandingSection.tsx deliberately never re-implements.
 */
export function normalizeHexInput(input: string): string | null {
  const cleaned = input.trim().replace(/^#/, '');
  const full = cleaned.length === 3 ? cleaned.split('').map((c) => c + c).join('') : cleaned;
  if (!/^[0-9a-fA-F]{6}$/.test(full)) return null;
  return `#${full.toUpperCase()}`;
}
